<template>
  <!--<a :href="item.href" :class="[item.current ? '' : 'text-gray-400 hover:text-white hover:bg-gray-800', 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold']">-->
  <div v-if="mustShow(item)">
    <div v-if="item?.type === 'subtitle'" class="ml-1 text-xs p-2 font-semibold leading-6 text-gray-400">{{ item?.title || '' }}</div>
    <div v-else-if="item?.type === 'sectionTitle'">
      <div v-if="['md', 'lg', 'xl'].includes(breakpoint)" class="my-4 ml-1 text-md p-2 font-semibold leading-6 text-white rounded-md c7o-bg-gradient">{{ item?.title || '' }}</div>
      <mdicon v-else name="minus" class="ml-3 flex items-center justify-center h-6 w-6"></mdicon>
    </div>
    <router-link
      v-else
      :to="item?.link"
      class="group flex gap-x-2 rounded-md p-2 text-sm leading-6 font-semibold text-gray-700 hover:text-indigo-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800"
      active-class="is-active bg-slate-100 text-violet-700 dark:bg-gray-800 dark:text-white"
    >
      <mdicon
        :name="item?.icon || 'minus'"
        :size="item?.iconSize || 20"
        :class="['ml-1 flex items-center justify-center h-6 w-6', item?.iconClass ? item.iconClass : 'text-gray-400 group-[.is-active]:text-indigo-600 group-hover:text-indigo-600']"
        aria-hidden="true"
      ></mdicon>
      <div v-if="['md', 'lg', 'xl'].includes(breakpoint)">
        {{ item?.title }}
      </div>
    </router-link>
  </div>
</template>

<script setup>
  defineProps({
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    breakpoint: {
      type: String,
      default: 'md',
    },
  });

  function mustShow(item) {
    // todo check if function, for now assume true / false or computed
    return item?.show === undefined || item.show;
  }
</script>

<style>
  .c7o-bg-gradient {
    background-image: linear-gradient(to bottom, rgba(61, 28, 110, 1), rgb(169, 122, 251));
    background-origin: padding-box;
  }
</style>
